function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><g clipPath="url(#a)"><path d="M30.609 3.617l-2.226-2.226c-1.948-1.948-5.01-1.948-6.957 0L4.174 18.643l-.278.279-.279.278L0 30.052c0 .557 0 1.113.557 1.392.278.278.556.556 1.113.556h.556L12.8 28.383h.278l.279-.557 17.252-17.252c1.947-1.948 1.947-5.009 0-6.957zM9.183 26.157l-5.287 1.67 1.67-5.288 3.617 3.617zM25.878 11.13L12.243 24.765l-5.008-5.009L20.87 6.122l5.008 5.008zm2.505-2.782l-.279.278-5.008-4.73.278-.279c.835-.834 1.948-.834 2.783 0l2.226 2.226c.834.835.834 1.948 0 2.505z" fill="currentColor" /></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h32v32H0z" /></clipPath></defs></svg>;
});


// WEBPACK FOOTER //
// ./src/components/Icon/icons/pencil.icon.svg